/* tslint:disable */
/* eslint-disable */
/**
 * Probonio full API Docs
 * If you stumbled upon this page and want to integrate Probonio into your business software [click here!](/api/external)    If you\'re looking for more information about Probonio [head over here](https://probonio.de)    **This documentation describes all Endpoints of the Probonio API. It\'s created for experienced Probonio Developers only!**   <a href=\"/openapi/logout\" target=\"_blank\"><button>     <h4>Click here to trigger a full logout from Keycloak.</h4> </button></a><br /> 
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { CreateKomboConnectionLinkDTO } from '../dto';
// @ts-ignore
import { KomboConnectInfoDTO } from '../dto';
// @ts-ignore
import { KomboHRSystemListDTO } from '../dto';
// @ts-ignore
import { KomboIntegrationListDTO } from '../dto';
// @ts-ignore
import { KomboIntegrationStatusDTO } from '../dto';
// @ts-ignore
import { SyncKomboIntegrationRequestDTO } from '../dto';
// @ts-ignore
import { ValidationErrorResponseDTO } from '../dto';
/**
 * KomboApi - axios parameter creator
 * @export
 */
export const KomboApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary create a Kombo connection link for initial setup of a new integration
         * @param {string} tenantId 
         * @param {CreateKomboConnectionLinkDTO} createKomboConnectionLinkDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createConnectionLink: async (tenantId: string, createKomboConnectionLinkDTO: CreateKomboConnectionLinkDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('createConnectionLink', 'tenantId', tenantId)
            // verify required parameter 'createKomboConnectionLinkDTO' is not null or undefined
            assertParamExists('createConnectionLink', 'createKomboConnectionLinkDTO', createKomboConnectionLinkDTO)
            const localVarPath = `/tenants/{tenantId}/integrations/kombo/createConnectionLink`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createKomboConnectionLinkDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary disconnect Kombo integration
         * @param {string} tenantId 
         * @param {string} integrationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableIntegration: async (tenantId: string, integrationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('disableIntegration', 'tenantId', tenantId)
            // verify required parameter 'integrationId' is not null or undefined
            assertParamExists('disableIntegration', 'integrationId', integrationId)
            const localVarPath = `/tenants/{tenantId}/integrations/kombo/{integrationId}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"integrationId"}}`, encodeURIComponent(String(integrationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary list all HR systems supported by the Kombo integration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableHRSystems: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/integrations/kombo/hrSystems`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get status of Kombo integration
         * @param {string} tenantId 
         * @param {string} integrationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIntegrationStatus: async (tenantId: string, integrationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getIntegrationStatus', 'tenantId', tenantId)
            // verify required parameter 'integrationId' is not null or undefined
            assertParamExists('getIntegrationStatus', 'integrationId', integrationId)
            const localVarPath = `/tenants/{tenantId}/integrations/kombo/{integrationId}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"integrationId"}}`, encodeURIComponent(String(integrationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary create a Kombo reconnect link to update invalid credentials
         * @param {string} tenantId 
         * @param {string} integrationId 
         * @param {string} [locale] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReconnectLink: async (tenantId: string, integrationId: string, locale?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getReconnectLink', 'tenantId', tenantId)
            // verify required parameter 'integrationId' is not null or undefined
            assertParamExists('getReconnectLink', 'integrationId', integrationId)
            const localVarPath = `/tenants/{tenantId}/integrations/kombo/{integrationId}/reconnectLink`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"integrationId"}}`, encodeURIComponent(String(integrationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary create a Kombo setup link to set parameters of an existing integration
         * @param {string} tenantId 
         * @param {string} integrationId 
         * @param {string} [locale] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSetupLink: async (tenantId: string, integrationId: string, locale?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getSetupLink', 'tenantId', tenantId)
            // verify required parameter 'integrationId' is not null or undefined
            assertParamExists('getSetupLink', 'integrationId', integrationId)
            const localVarPath = `/tenants/{tenantId}/integrations/kombo/{integrationId}/setupLink`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"integrationId"}}`, encodeURIComponent(String(integrationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {'HRIS'} integrationType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listIntegrations: async (tenantId: string, integrationType: 'HRIS', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('listIntegrations', 'tenantId', tenantId)
            // verify required parameter 'integrationType' is not null or undefined
            assertParamExists('listIntegrations', 'integrationType', integrationType)
            const localVarPath = `/tenants/{tenantId}/integrations/kombo`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (integrationType !== undefined) {
                localVarQueryParameter['integrationType'] = integrationType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary update employees from the configured HR system
         * @param {string} tenantId 
         * @param {string} integrationId 
         * @param {SyncKomboIntegrationRequestDTO} syncKomboIntegrationRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncIntegration: async (tenantId: string, integrationId: string, syncKomboIntegrationRequestDTO: SyncKomboIntegrationRequestDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('syncIntegration', 'tenantId', tenantId)
            // verify required parameter 'integrationId' is not null or undefined
            assertParamExists('syncIntegration', 'integrationId', integrationId)
            // verify required parameter 'syncKomboIntegrationRequestDTO' is not null or undefined
            assertParamExists('syncIntegration', 'syncKomboIntegrationRequestDTO', syncKomboIntegrationRequestDTO)
            const localVarPath = `/tenants/{tenantId}/integrations/kombo/{integrationId}/sync`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"integrationId"}}`, encodeURIComponent(String(integrationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(syncKomboIntegrationRequestDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * KomboApi - functional programming interface
 * @export
 */
export const KomboApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = KomboApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary create a Kombo connection link for initial setup of a new integration
         * @param {string} tenantId 
         * @param {CreateKomboConnectionLinkDTO} createKomboConnectionLinkDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createConnectionLink(tenantId: string, createKomboConnectionLinkDTO: CreateKomboConnectionLinkDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<KomboConnectInfoDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createConnectionLink(tenantId, createKomboConnectionLinkDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary disconnect Kombo integration
         * @param {string} tenantId 
         * @param {string} integrationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async disableIntegration(tenantId: string, integrationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.disableIntegration(tenantId, integrationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary list all HR systems supported by the Kombo integration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAvailableHRSystems(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<KomboHRSystemListDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAvailableHRSystems(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary get status of Kombo integration
         * @param {string} tenantId 
         * @param {string} integrationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIntegrationStatus(tenantId: string, integrationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<KomboIntegrationStatusDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIntegrationStatus(tenantId, integrationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary create a Kombo reconnect link to update invalid credentials
         * @param {string} tenantId 
         * @param {string} integrationId 
         * @param {string} [locale] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReconnectLink(tenantId: string, integrationId: string, locale?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<KomboConnectInfoDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReconnectLink(tenantId, integrationId, locale, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary create a Kombo setup link to set parameters of an existing integration
         * @param {string} tenantId 
         * @param {string} integrationId 
         * @param {string} [locale] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSetupLink(tenantId: string, integrationId: string, locale?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<KomboConnectInfoDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSetupLink(tenantId, integrationId, locale, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {'HRIS'} integrationType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listIntegrations(tenantId: string, integrationType: 'HRIS', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<KomboIntegrationListDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listIntegrations(tenantId, integrationType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary update employees from the configured HR system
         * @param {string} tenantId 
         * @param {string} integrationId 
         * @param {SyncKomboIntegrationRequestDTO} syncKomboIntegrationRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncIntegration(tenantId: string, integrationId: string, syncKomboIntegrationRequestDTO: SyncKomboIntegrationRequestDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncIntegration(tenantId, integrationId, syncKomboIntegrationRequestDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * KomboApi - factory interface
 * @export
 */
export const KomboApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = KomboApiFp(configuration)
    return {
        /**
         * 
         * @summary create a Kombo connection link for initial setup of a new integration
         * @param {string} tenantId 
         * @param {CreateKomboConnectionLinkDTO} createKomboConnectionLinkDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createConnectionLink(tenantId: string, createKomboConnectionLinkDTO: CreateKomboConnectionLinkDTO, options?: any): AxiosPromise<KomboConnectInfoDTO> {
            return localVarFp.createConnectionLink(tenantId, createKomboConnectionLinkDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary disconnect Kombo integration
         * @param {string} tenantId 
         * @param {string} integrationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableIntegration(tenantId: string, integrationId: string, options?: any): AxiosPromise<void> {
            return localVarFp.disableIntegration(tenantId, integrationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary list all HR systems supported by the Kombo integration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableHRSystems(options?: any): AxiosPromise<KomboHRSystemListDTO> {
            return localVarFp.getAvailableHRSystems(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get status of Kombo integration
         * @param {string} tenantId 
         * @param {string} integrationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIntegrationStatus(tenantId: string, integrationId: string, options?: any): AxiosPromise<KomboIntegrationStatusDTO> {
            return localVarFp.getIntegrationStatus(tenantId, integrationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary create a Kombo reconnect link to update invalid credentials
         * @param {string} tenantId 
         * @param {string} integrationId 
         * @param {string} [locale] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReconnectLink(tenantId: string, integrationId: string, locale?: string, options?: any): AxiosPromise<KomboConnectInfoDTO> {
            return localVarFp.getReconnectLink(tenantId, integrationId, locale, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary create a Kombo setup link to set parameters of an existing integration
         * @param {string} tenantId 
         * @param {string} integrationId 
         * @param {string} [locale] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSetupLink(tenantId: string, integrationId: string, locale?: string, options?: any): AxiosPromise<KomboConnectInfoDTO> {
            return localVarFp.getSetupLink(tenantId, integrationId, locale, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {'HRIS'} integrationType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listIntegrations(tenantId: string, integrationType: 'HRIS', options?: any): AxiosPromise<KomboIntegrationListDTO> {
            return localVarFp.listIntegrations(tenantId, integrationType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary update employees from the configured HR system
         * @param {string} tenantId 
         * @param {string} integrationId 
         * @param {SyncKomboIntegrationRequestDTO} syncKomboIntegrationRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncIntegration(tenantId: string, integrationId: string, syncKomboIntegrationRequestDTO: SyncKomboIntegrationRequestDTO, options?: any): AxiosPromise<void> {
            return localVarFp.syncIntegration(tenantId, integrationId, syncKomboIntegrationRequestDTO, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createConnectionLink operation in KomboApi.
 * @export
 * @interface KomboApiCreateConnectionLinkRequest
 */
export interface KomboApiCreateConnectionLinkRequest {
    /**
     * 
     * @type {string}
     * @memberof KomboApiCreateConnectionLink
     */
    readonly tenantId: string

    /**
     * 
     * @type {CreateKomboConnectionLinkDTO}
     * @memberof KomboApiCreateConnectionLink
     */
    readonly createKomboConnectionLinkDTO: CreateKomboConnectionLinkDTO
}

/**
 * Request parameters for disableIntegration operation in KomboApi.
 * @export
 * @interface KomboApiDisableIntegrationRequest
 */
export interface KomboApiDisableIntegrationRequest {
    /**
     * 
     * @type {string}
     * @memberof KomboApiDisableIntegration
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof KomboApiDisableIntegration
     */
    readonly integrationId: string
}

/**
 * Request parameters for getIntegrationStatus operation in KomboApi.
 * @export
 * @interface KomboApiGetIntegrationStatusRequest
 */
export interface KomboApiGetIntegrationStatusRequest {
    /**
     * 
     * @type {string}
     * @memberof KomboApiGetIntegrationStatus
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof KomboApiGetIntegrationStatus
     */
    readonly integrationId: string
}

/**
 * Request parameters for getReconnectLink operation in KomboApi.
 * @export
 * @interface KomboApiGetReconnectLinkRequest
 */
export interface KomboApiGetReconnectLinkRequest {
    /**
     * 
     * @type {string}
     * @memberof KomboApiGetReconnectLink
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof KomboApiGetReconnectLink
     */
    readonly integrationId: string

    /**
     * 
     * @type {string}
     * @memberof KomboApiGetReconnectLink
     */
    readonly locale?: string
}

/**
 * Request parameters for getSetupLink operation in KomboApi.
 * @export
 * @interface KomboApiGetSetupLinkRequest
 */
export interface KomboApiGetSetupLinkRequest {
    /**
     * 
     * @type {string}
     * @memberof KomboApiGetSetupLink
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof KomboApiGetSetupLink
     */
    readonly integrationId: string

    /**
     * 
     * @type {string}
     * @memberof KomboApiGetSetupLink
     */
    readonly locale?: string
}

/**
 * Request parameters for listIntegrations operation in KomboApi.
 * @export
 * @interface KomboApiListIntegrationsRequest
 */
export interface KomboApiListIntegrationsRequest {
    /**
     * 
     * @type {string}
     * @memberof KomboApiListIntegrations
     */
    readonly tenantId: string

    /**
     * 
     * @type {'HRIS'}
     * @memberof KomboApiListIntegrations
     */
    readonly integrationType: 'HRIS'
}

/**
 * Request parameters for syncIntegration operation in KomboApi.
 * @export
 * @interface KomboApiSyncIntegrationRequest
 */
export interface KomboApiSyncIntegrationRequest {
    /**
     * 
     * @type {string}
     * @memberof KomboApiSyncIntegration
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof KomboApiSyncIntegration
     */
    readonly integrationId: string

    /**
     * 
     * @type {SyncKomboIntegrationRequestDTO}
     * @memberof KomboApiSyncIntegration
     */
    readonly syncKomboIntegrationRequestDTO: SyncKomboIntegrationRequestDTO
}

/**
 * KomboApi - object-oriented interface
 * @export
 * @class KomboApi
 * @extends {BaseAPI}
 */
export class KomboApi extends BaseAPI {
    /**
     * 
     * @summary create a Kombo connection link for initial setup of a new integration
     * @param {KomboApiCreateConnectionLinkRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KomboApi
     */
    public createConnectionLink(requestParameters: KomboApiCreateConnectionLinkRequest, options?: AxiosRequestConfig) {
        return KomboApiFp(this.configuration).createConnectionLink(requestParameters.tenantId, requestParameters.createKomboConnectionLinkDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary disconnect Kombo integration
     * @param {KomboApiDisableIntegrationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KomboApi
     */
    public disableIntegration(requestParameters: KomboApiDisableIntegrationRequest, options?: AxiosRequestConfig) {
        return KomboApiFp(this.configuration).disableIntegration(requestParameters.tenantId, requestParameters.integrationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary list all HR systems supported by the Kombo integration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KomboApi
     */
    public getAvailableHRSystems(options?: AxiosRequestConfig) {
        return KomboApiFp(this.configuration).getAvailableHRSystems(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get status of Kombo integration
     * @param {KomboApiGetIntegrationStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KomboApi
     */
    public getIntegrationStatus(requestParameters: KomboApiGetIntegrationStatusRequest, options?: AxiosRequestConfig) {
        return KomboApiFp(this.configuration).getIntegrationStatus(requestParameters.tenantId, requestParameters.integrationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary create a Kombo reconnect link to update invalid credentials
     * @param {KomboApiGetReconnectLinkRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KomboApi
     */
    public getReconnectLink(requestParameters: KomboApiGetReconnectLinkRequest, options?: AxiosRequestConfig) {
        return KomboApiFp(this.configuration).getReconnectLink(requestParameters.tenantId, requestParameters.integrationId, requestParameters.locale, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary create a Kombo setup link to set parameters of an existing integration
     * @param {KomboApiGetSetupLinkRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KomboApi
     */
    public getSetupLink(requestParameters: KomboApiGetSetupLinkRequest, options?: AxiosRequestConfig) {
        return KomboApiFp(this.configuration).getSetupLink(requestParameters.tenantId, requestParameters.integrationId, requestParameters.locale, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {KomboApiListIntegrationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KomboApi
     */
    public listIntegrations(requestParameters: KomboApiListIntegrationsRequest, options?: AxiosRequestConfig) {
        return KomboApiFp(this.configuration).listIntegrations(requestParameters.tenantId, requestParameters.integrationType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary update employees from the configured HR system
     * @param {KomboApiSyncIntegrationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KomboApi
     */
    public syncIntegration(requestParameters: KomboApiSyncIntegrationRequest, options?: AxiosRequestConfig) {
        return KomboApiFp(this.configuration).syncIntegration(requestParameters.tenantId, requestParameters.integrationId, requestParameters.syncKomboIntegrationRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
}
